var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import styled from '@emotion/styled';
import { TableRow as MuiTableRow } from '@mui/material';
import hexrgb from 'hex-rgb';
import { useState } from 'react';
import colors from '../../themes/colors';
import TableExpandableCell from './Table.ExpandableCell';
import { renderCell } from './utils';
var neutral5Hover = hexrgb(colors.neutral5, { format: 'object' });
var hover5Color = "rgba(".concat(neutral5Hover.red, ", ").concat(neutral5Hover.green, ", ").concat(neutral5Hover.blue, ", 0.2)");
var StyledMuiRow = styled(MuiTableRow)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  background-color: ", ";\n"], ["\n  ", "\n  background-color: ", ";\n"])), function (_a) {
    var highlightOdds = _a.highlightOdds, index = _a.index;
    if (highlightOdds) {
        return "\n        border: none;\n        & > .MuiTableCell-root {\n          border-bottom: none !important;\n        }\n        &:hover > .MuiTableCell-root {\n          background-color: ".concat(index % 2 ? colors.neutral5 : hover5Color, " !important;\n        }\n      ");
    }
    return '';
}, function (_a) {
    var highlightOdds = _a.highlightOdds, index = _a.index;
    return highlightOdds && index % 2 === 0 ? colors.neutral0 : colors.white;
});
export default function TableRow(props) {
    var columns = props.columns, row = props.row, config = props.config, index = props.index, variant = props.variant, collapsedRows = props.collapsedRows, toggleRowExpand = props.toggleRowExpand;
    var isExpandable = variant === 'expandable';
    var _a = useState(false), isHovering = _a[0], setIsHovering = _a[1];
    var onRowClick = function (e) {
        if (config === null || config === void 0 ? void 0 : config.onRowClick) {
            config.onRowClick(row, index, e);
        }
    };
    var onRowMouseEnter = function () {
        if (config === null || config === void 0 ? void 0 : config.onRowMouseEnter) {
            config === null || config === void 0 ? void 0 : config.onRowMouseEnter(row, index);
        }
        setIsHovering(true);
    };
    var onRowMouseLeave = function () {
        if (config === null || config === void 0 ? void 0 : config.onRowMouseLeave) {
            config === null || config === void 0 ? void 0 : config.onRowMouseLeave(row, index);
        }
        setIsHovering(false);
    };
    var sx = {};
    if (config === null || config === void 0 ? void 0 : config.onRowClick) {
        sx.cursor = 'pointer';
    }
    return (_jsxs(StyledMuiRow, __assign({ highlightOdds: isExpandable, index: index, datatype: variant, hover: true, sx: sx, onMouseLeave: onRowMouseLeave, onMouseEnter: onRowMouseEnter, onClick: onRowClick }, { children: [isExpandable && (_createElement(TableExpandableCell, __assign({}, props, { key: "expandable_cell_".concat(index), index: index, open: collapsedRows[index], onCollapseClick: toggleRowExpand }))), columns.map(function (column, cidx) {
                return renderCell({
                    config: config,
                    row: row,
                    column: column,
                    rowIndex: index,
                    index: cidx,
                    isHovering: isHovering
                });
            })] })));
}
var templateObject_1;
